export default __webpack_public_path__ + "static/media/depositMethod.3e41a8a9.svg";